/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API;

const state = {
    breakdownGuides: [],
    groupedGuides: [],
    guidesFilter: {
        day_init: null,
        day_end: null,
        guide_id: 0
    },
    breakdownBusCompanies: [],
    busCompaniesFilter: {
        day_init: null,
        day_end: null,
        bus_company_id: 0
    }
}

const actions = {
    async retrieveBreakdownBusCompanies({
        commit, dispatch
    }, payload) {
        // it retrieves analytics breakdown of bus companies by date range
        let url = baseUrl
        if ( payload.bus_company_id == 0 || payload.bus_company_id == null ) {
            url += '/excursion/analytics-bus-company/retrieve_breakdown_bus_companies/?day_init='+payload.day_init+'&day_end='+payload.day_end
        } else {
            url += '/excursion/analytics-bus-company/retrieve_breakdown_bus_companies/?day_init='+payload.day_init+'&day_end='+payload.day_end+'&bus_company_id='+payload.bus_company_id
        }
        return axios
            .get(
                url
            )
            .then(response => {
                commit('SET_BREAKDOWN_BUS_COMPANIES', response.data)
                return response.data
            })
    },
    async retrieveBreakdownGuides({
        commit, dispatch
    }, payload ) {
        // retrieve analytics breakdown of guides by date range
        let url = baseUrl
        if ( payload.guide_id == 0 || payload.guide_id == null ) {
            url += '/excursion/analytics-guide/retrieve_breakdown_guides/?day_init='+payload.day_init+'&day_end='+payload.day_end
        } else {
            url += '/excursion/analytics-guide/retrieve_breakdown_guides/?day_init='+payload.day_init+'&day_end='+payload.day_end+'&guide_id='+payload.guide_id
        }
        return axios
            .get(
                url
            )
            .then(response => {
                commit('SET_BREAKDOWN_GUIDES', response.data)
                return response.data
            })
    },
    async retrieveGroupedGuides({
        commit, dispatch
    }, payload ) {
        // retrieve analytics grouped of guides by date range
        let url = baseUrl
        if ( payload.guide_id == 0 || payload.guide_id == null ) {
            url += '/excursion/analytics-guide/retrieve_grouped_guides/?day_init='+payload.day_init+'&day_end='+payload.day_end
        } else {
            url += '/excursion/analytics-guide/retrieve_grouped_guides/?day_init='+payload.day_init+'&day_end='+payload.day_end+'&guide_id='+payload.guide_id
        }
        return axios
            .get(
                url
            )
            .then(response => {
                commit('SET_GROUPED_GUIDES', response.data)
                return response.data
            })
    },
    updateGuideFilter({
        commit, dispatch
    }, payload ) {
        commit('UPDATE_GUIDE_FILTER', payload)
    },
    updateBusCompanyFilter({
        commit, dispatch
    }, payload ) {
        commit('UPDATE_BUS_COMPANY_FILTER', payload)
    }
}

const mutations = {
    SET_BREAKDOWN_GUIDES(state, breakdown) {
        state.breakdownGuides = breakdown
    },
    SET_GROUPED_GUIDES(state, grouped) {
        state.groupedGuides = grouped
    },
    UPDATE_GUIDE_FILTER(state, filter) {
        state.guidesFilter = {
            day_init: filter.day_init != null ? filter.day_init : state.guidesFilter.day_init,
            day_end: filter.day_end != null ? filter.day_end : state.guidesFilter.day_end,
            guide_id: filter.guide_id != null ? filter.guide_id : state.guidesFilter.guide_id
        }
    },
    SET_BREAKDOWN_BUS_COMPANIES(state, breakdown) {
        state.breakdownBusCompanies = breakdown
    },
    UPDATE_BUS_COMPANY_FILTER(state, filter) {
        state.busCompaniesFilter = {
            day_init: filter.day_init != null ? filter.day_init : state.busCompaniesFilter.day_init,
            day_end: filter.day_end != null ? filter.day_end : state.busCompaniesFilter.day_end,
            bus_company_id: filter.bus_company_id != null ? filter.bus_company_id : state.busCompaniesFilter.bus_company_id
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}